export default {
    pageNumberUpdated: 'page-number-updated',
    resultsFetched: 'results-fetched',
    setPagination: 'set-pagination'
}